class DrawerMenuPanels extends HTMLElement {
  constructor() {
    super();
    this.onOpenClick = this.onOpenClick.bind(this);
    this.onBackClick = this.onBackClick.bind(this);
    this.reset = this.reset.bind(this);
  }

  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;

    this.openButtons = Array.from(this.querySelectorAll('[data-panel-open]'));
    this.backButtons = Array.from(this.querySelectorAll('[data-panel-back]'));

    this.openButtons.forEach((button) => button.addEventListener('click', this.onOpenClick));
    this.backButtons.forEach((button) => button.addEventListener('click', this.onBackClick));

    this.drawer = this.closest('menu-drawer');
    if (this.drawer) {
      this.drawer.addEventListener('drawer:afterHide', this.reset);
    }
  }

  disconnectedCallback() {
    this.openButtons?.forEach((button) => button.removeEventListener('click', this.onOpenClick));
    this.backButtons?.forEach((button) => button.removeEventListener('click', this.onBackClick));
    this.drawer?.removeEventListener('drawer:afterHide', this.reset);
    this.initialized = false;
  }

  panelFor(id) {
    return this.querySelector(`.niccos-drawer-mo__panel[data-panel="${id}"]`);
  }

  onOpenClick(event) {
    event.preventDefault();

    const button = event.currentTarget;
    const id = button.getAttribute('data-panel-open');
    const panel = this.panelFor(id);
    if (!panel) return;

    this.closeAll();

    panel.classList.add('is-active');
    panel.setAttribute('aria-hidden', 'false');
    button.setAttribute('aria-expanded', 'true');
    this.classList.add('niccos-drawer-mo--sub-open');
    this.activePanel = panel;
    this.activeButton = button;

    const firstFocusable = panel.querySelector('a, button');
    firstFocusable?.focus({ preventScroll: true });
  }

  onBackClick(event) {
    event.preventDefault();
    this.closeAll();
  }

  closeAll() {
    this.querySelectorAll('.niccos-drawer-mo__panel.is-active').forEach((panel) => {
      panel.classList.remove('is-active');
      panel.setAttribute('aria-hidden', 'true');
    });
    this.openButtons?.forEach((button) => button.setAttribute('aria-expanded', 'false'));
    this.classList.remove('niccos-drawer-mo--sub-open');

    if (this.activeButton) {
      this.activeButton.focus({ preventScroll: true });
      this.activeButton = null;
    }
    this.activePanel = null;
  }

  reset() {
    this.activeButton = null;
    this.activePanel = null;
    this.closeAll();
  }
}

customElements.define('drawer-menu-panels', DrawerMenuPanels);
